import { type Theme, styled } from 'baseui';
import type { ButtonOverrides } from 'baseui/button';
import { type SegmentedControlOverrides } from 'baseui/segmented-control';
import { type SelectOverrides } from 'baseui/select';
import { HeadingXSmall } from 'baseui/typography';
export const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: `${$theme.sizing.scale800} ${$theme.sizing.scale800} 0`,
  backgroundColor: $theme.colors.backgroundPrimary,
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  position: 'relative'
}));
export const PanelContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: `calc(100% - ${$theme.sizing.scale1200})`
}));
export const PanelHeader = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: $theme.sizing.scale700
}));
export const SectionHeader = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: $theme.sizing.scale500,
  gap: $theme.sizing.scale300
}));
export const StyledHeading = styled<typeof HeadingXSmall, {
  $subSectionHeader?: boolean;
}>(HeadingXSmall, ({
  $theme,
  $subSectionHeader
}) => ({
  letterSpacing: '0.25px',
  margin: 0,
  fontSize: $subSectionHeader ? $theme.sizing.scale600 : $theme.sizing.scale650,
  color: $subSectionHeader ? $theme.colors.contentSecondary : $theme.colors.contentPrimary,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));
export const NavigationContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale100
}));
export const ObjectClassificationContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'auto',
  marginBottom: $theme.sizing.scale500
}));
export const StickyActionContainer = styled('div', ({
  $theme
}) => ({
  boxShadow: $theme.lighting.shallowAbove,
  position: 'sticky',
  margin: `0 -${$theme.sizing.scale800}`,
  padding: `${$theme.sizing.scale500} ${$theme.sizing.scale750} ${$theme.sizing.scale650}`,
  display: 'flex',
  justifyContent: 'space-evenly',
  gap: $theme.sizing.scale400
}));
export const searchInputOverrides: SelectOverrides = {
  ControlContainer: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      borderRadius: $theme.borders.radius500
    })
  }
};
export const segmentedControlOverrides: SegmentedControlOverrides = {
  Root: {
    style: {
      width: '100%',
      flexShrink: 0
    }
  }
};
export const actionButtonOverrides: ButtonOverrides = {
  Root: {
    style: {
      flex: 1
    }
  }
};